/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntAppControllerSegmentsSearchQueryResponse, PntAppControllerSegmentsSearchPathParams, PntAppControllerSegmentsSearchQueryParams } from "../models/PntAppControllerSegmentsSearch";

export function getPntAppControllerSegmentsSearchUrl(slug: PntAppControllerSegmentsSearchPathParams["slug"]) {
  const res = { method: 'GET', url: `/pnt/v2/segments/${slug}/search` as const }
  return res
}

/**
 * @summary Search segment transcriptions for given terms within a date range.
 * {@link /pnt/v2/segments/:slug/search}
 */
export async function pntAppControllerSegmentsSearch(slug: PntAppControllerSegmentsSearchPathParams["slug"], params: PntAppControllerSegmentsSearchQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PntAppControllerSegmentsSearchQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPntAppControllerSegmentsSearchUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}